function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { t } from '../i18n';
import { SvgIcon } from './SvgIcon';
var defaultProps = {
  className: '',
  viewBox: '-2 -2 18 18'
};
export function CloseIconThin(props) {
  var iconCssClasses = "ds-c-icon--close ds-c-icon--close-thin ".concat(props.className || '');
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: t('icons.close')
  }, defaultProps, props, {
    className: iconCssClasses
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M0 13.0332964L13.0332964 0M13.0332964 13.0332964L0 0"
  }));
}